import NavigationsPage from "@containers/NavigationsPage/NavigationPage"
import PageWrapper from "@components/Common/PageWrapper"
import styles from "./ViewPatientPage.module.css"
import ViewPatient from "@components/ViewPatientPage/ViewPatient"

const ViewPatientPage = () => {
  return (
    <NavigationsPage
      defaultBackgroundClassName={styles.defaultBackgroundClassName}
    >
      <PageWrapper className={styles.viewPatientPage}>
        <ViewPatient />
      </PageWrapper>
    </NavigationsPage>
  )
}

export default ViewPatientPage
